import React from 'react';
import { useDispatch } from 'react-redux';
import SelectField from '../../../../FormControl/input/SelectField';
import { updateSurveyBuilder } from '../../../../../store/actions/dataEntrySurveyBuilderActions';
import CardKeyValue from '../../../../card/cardKeyValue';
export const rolesRelatedClasses = ['Student', 'Teacher', 'Parent'];

const Constraints = ({ error, value, disabled, isPreview, loading }) => {
  const dispatch = useDispatch();
  const options = [
    {
      value : 'Student',
      label: 'Students evaluate Teachers'
    },

    {
      value : 'Parent',
      label: 'Parents evaluate Teachers'
    }
  ]

  const onChangeCoinstraints = (rolesId) => {
    const constraints = {
      rolesId: [rolesId],
      classRelated: true
    };
    dispatch(updateSurveyBuilder({ constraints }));
  }

  if (isPreview) {
    return (
      <CardKeyValue
      className='min-w-150px max-w-150px '
      title='Preferences'
      lines={1}
      loading={loading}
      iconClassName='text-2xl'
      value={options.find((option) => option.value === value)?.label || ''}
    />
    )
  }
  return (
    <SelectField
      label='Preferences'
      error={error}
      helperText={error}                    
      value={value || ''}
      onChange={(e) => onChangeCoinstraints(e.target.value)}      
      options={options}
      placeholder="Choose an option"
      disabled={disabled}
    />  
  );
};

export default Constraints;
